import { render, staticRenderFns } from "./batchAdd.vue?vue&type=template&id=1bb567c4&scoped=true"
import script from "./batchAdd.vue?vue&type=script&lang=js"
export * from "./batchAdd.vue?vue&type=script&lang=js"
import style0 from "./batchAdd.vue?vue&type=style&index=0&id=1bb567c4&prod&scoped=true&lang=css"
import style1 from "./batchAdd.vue?vue&type=style&index=1&id=1bb567c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb567c4",
  null
  
)

export default component.exports